/**
 * Status chip color helper
 */
export const getStatusColor = (status) => {
  switch (status) {
    case 'Canlı':
      return 'success';
    case 'Taslak':
      return 'warning';
    case 'Durduruldu':
      return 'error';
    default:
      return 'default';
  }
};

/**
 * Hide elements marked for screenshot export cleanup
 */
function hideForExport(element, selector) {
  const nodes = element.querySelectorAll(selector);
  nodes.forEach((node) => {
    node.dataset.prevDisplay = node.style.display;
    node.style.display = 'none';
  });
  return nodes;
}

function restoreExport(element, selector) {
  element.querySelectorAll(selector).forEach((node) => {
    node.style.display = node.dataset.prevDisplay || '';
    delete node.dataset.prevDisplay;
  });
}

/**
 * Copy report HTML element as PNG to clipboard
 */
export const copyElementAsImage = async (element, onSuccess, onError) => {
  if (!element) return;

  try {
    hideForExport(element, '[data-report-copy-hide]');
    hideForExport(element, '.report-export-hide');
    hideForExport(element, '[data-field="monthly"]');
    hideForExport(element, '[data-field="yearly"]');

    const metricsSidebar = element.querySelector('.metrics-sidebar');
    if (metricsSidebar) {
      metricsSidebar.dataset.prevDisplay = metricsSidebar.style.display;
      metricsSidebar.style.display = 'none';
    }

    const reportWrapper = element.querySelector('.report-content-wrapper');
    const mainContent = element.querySelector('.report-main-content');
    if (reportWrapper) reportWrapper.style.gap = '0';
    if (mainContent) mainContent.style.width = '100%';

    const html2canvas = await import('html2canvas');
    const canvas = await html2canvas.default(element, {
      scale: 2,
      backgroundColor: '#ffffff',
    });

    if (metricsSidebar) {
      metricsSidebar.style.display = metricsSidebar.dataset.prevDisplay || '';
      delete metricsSidebar.dataset.prevDisplay;
    }
    if (reportWrapper) reportWrapper.style.gap = '';
    if (mainContent) mainContent.style.width = '';

    restoreExport(element, '[data-report-copy-hide]');
    restoreExport(element, '.report-export-hide');
    restoreExport(element, '[data-field="monthly"]');
    restoreExport(element, '[data-field="yearly"]');

    canvas.toBlob((blob) => {
      const item = new ClipboardItem({ 'image/png': blob });
      navigator.clipboard.write([item]).then(() => {
        if (onSuccess) onSuccess();
      });
    });
  } catch (error) {
    console.error('Ekran görüntüsü alınırken hata:', error);
    if (onError) onError();
  }
};

/**
 * Export report analysis rows as CSV download
 */
export const exportReportToCSV = (reportData, onSuccess, onError) => {
  if (!reportData) return;

  try {
    const { analysis, reportName } = reportData;

    const headers = ['Variant', 'Sessions', 'Transactions', 'Conv. Rate', 'Uplift', 'Signif.'];

    const rows = [
      [
        'Kontrol',
        analysis.control.sessions,
        analysis.control.conversions,
        `${analysis.control.cr.toFixed(2)}%`,
        '-',
        `${analysis.stats.controlProbability}%`,
      ],
      [
        analysis.variant.name || 'Varyasyon 1',
        analysis.variant.sessions,
        analysis.variant.conversions,
        `${analysis.variant.cr.toFixed(2)}%`,
        `${analysis.improvement.toFixed(2)}%`,
        `${analysis.stats.variantProbability}%`,
      ],
    ];

    let csvContent = `${headers.join(',')}\n`;
    rows.forEach((row) => {
      csvContent += `${row.join(',')}\n`;
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${reportName.replace(/[^\w\s]/gi, '_')}.csv`;
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    if (onSuccess) onSuccess();
  } catch (error) {
    console.error('CSV dışa aktarma hatası:', error);
    if (onError) onError();
  }
};
